import i18n, { LOCALE_MAP } from "@/i18n";

function currentLocale() {
  return LOCALE_MAP[i18n.language] || "de-DE";
}

export function formatCurrency(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  const fmt = new Intl.NumberFormat(currentLocale(), {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  return `$ ${fmt.format(Math.round(Number(value)))}`;
}

export function formatInt(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  const fmt = new Intl.NumberFormat(currentLocale(), { maximumFractionDigits: 0 });
  return fmt.format(Math.round(Number(value)));
}

export function formatPercent(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  const fmt = new Intl.NumberFormat(currentLocale(), {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  const n = Math.round(Number(value));
  const sign = n >= 0 ? "+" : "-";
  return `${sign}${fmt.format(Math.abs(n))} %`;
}

export function formatAxisShort(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return "";
  const fmt = new Intl.NumberFormat(currentLocale(), { maximumFractionDigits: 0 });
  const n = Math.abs(Number(value));
  if (n >= 1_000_000) return `$ ${fmt.format(Number(value) / 1_000_000)}M`;
  if (n >= 1_000) return `$ ${fmt.format(Number(value) / 1_000)}k`;
  return `$ ${fmt.format(value)}`;
}
